<template>
  <div>
    <ActionBar>
      <ActionBarTitle>รายการซื้อ ขาย แลกเปลี่ยน</ActionBarTitle>
    </ActionBar>

    <PageContainer>
      <Container>
        <HistoryFilter
          :query.sync="query.q"
          :type.sync="query.type"
          :start.sync="query.start"
          :end.sync="query.end"
          @submit="handleSubmit"
        />
        <HistoryResult
          ref="result"
          :query="query.q"
          :type="query.type"
          :start="query.start"
          :end="query.end"
          :page.sync="query.page"
          :style="{ marginTop: '1.5rem' }"
          @page-change="handlePageChange"
        />
      </Container>
    </PageContainer>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import { datetimeMixin, numberMixin } from '@/mixins'
import { ActionBar, ActionBarTitle } from '@/components/ui/action-bar'
import { PageContainer } from '@/components/page/page-container'
import { AppContainer as Container } from '@/components/ui/container'
import { SearchInput } from '@/components/page/search-input'
import { ResultCounter } from '@/components/page/result-counter'
import styles from './History.module.scss'
import { ReceiptService } from '@/services'
import elementUiStyles from '@/assets/scss/modules/element-ui.module.scss'

const ActivityTag = Vue.extend({
  functional: true,

  props: {
    type: {
      type: String,
      default: ''
    }
  },

  render(h, { props }) {
    const type = (type => {
      switch (type) {
        case 'sell':
          return {
            text: 'ขายทอง',
            color: '#ffc11d'
          }

        case 'buy':
          return {
            text: 'ซื้อทอง',
            color: '#ffe83a'
          }

        case 'trade/sell':
        case 'trade/buy':
          return {
            text: 'แลกเปลี่ยน',
            color: '#dcd0b1'
          }

        case 'pawn':
          return {
            text: 'ขายฝาก',
            color: '#fff4a7'
          }
      }
    })(props.type)

    return (
      type && (
        <el-tag
          color={type.color}
          style={{
            color: 'black',
            borderColor: type.color,
            fontSize: 'inherit'
          }}
        >
          {type.text}
        </el-tag>
      )
    )
  }
})

const SeeDetailButton = Vue.extend({
  props: {
    receiptId: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },

  methods: {
    handleClick() {
      if (this.receiptId && this.type)
        switch (this.type) {
          case 'sell':
            this.$router.push({
              name: 'SellDetail',
              params: { id: this.receiptId }
            })
            break

          case 'buy':
            this.$router.push({
              name: 'BuyDetail',
              params: { id: this.receiptId }
            })
            break

          case 'trade/sell':
            this.$router.push({
              name: 'TradeDetail',
              params: { type: 'sell', id: this.receiptId }
            })
            break

          case 'trade/buy':
            this.$router.push({
              name: 'TradeDetail',
              params: { type: 'buy', id: this.receiptId }
            })
            break
        }
    }
  },

  render() {
    return (
      <el-button size="medium" onClick={this.handleClick}>
        See Detail <i class="el-icon-arrow-right"></i>
      </el-button>
    )
  }
})

const HistoryFilter = Vue.extend({
  props: {
    query: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    start: {
      type: Date,
      default: undefined
    },
    end: {
      type: Date,
      default: undefined
    }
  },

  render() {
    const types = [
      { value: '', label: 'ทั้งหมด' },
      { value: 'sell', label: 'ขายทอง' },
      { value: 'buy', label: 'ซื้อทอง' },
      { value: 'trade', label: 'แลกเปลี่ยนทอง' }
    ]

    return (
      <el-card>
        <h1 style={{ fontSize: '1.125rem' }}>ค้นหา</h1>
        <el-row type="flex" gutter={32} style={{ flexWrap: 'wrap' }}>
          <el-col sm={16}>
            <SearchInput
              placeholder="ID, เลขที่ใบรับประกัน, ชื่อลูกค้า, เบอร์โทร"
              value={this.query}
              onInput={value => {
                this.$emit('update:query', value)
              }}
              onSubmit={() => {
                this.$emit('submit')
              }}
            />
          </el-col>
          <el-col sm={8}>
            <el-select
              value={this.type}
              class={styles.typeSelect}
              onChange={value => {
                this.$emit('update:type', value)
                this.$emit('submit')
              }}
            >
              {types.map(type => (
                <el-option label={type.label} value={type.value} />
              ))}
            </el-select>
          </el-col>
        </el-row>
        <el-form inline style={{ marginTop: '1rem' }}>
          <el-form-item label="ช่วงเวลา">
            <el-date-picker
              value={[this.start, this.end]}
              type="daterange"
              startPlaceholder="Start Date"
              endPlaceholder="End Date"
              onInput={value => {
                if (!value) {
                  this.$emit('update:start', undefined)
                  this.$emit('update:end', undefined)
                  this.$emit('submit')
                  return
                }

                const [start, end] = value
                this.$emit('update:start', start)
                this.$emit('update:end', end)
                this.$emit('submit')
              }}
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </el-card>
    )
  }
})

const HistoryResult = Vue.extend({
  mixins: [datetimeMixin, numberMixin],

  props: {
    query: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    start: {
      type: Date,
      default: null
    },
    end: {
      type: Date,
      default: null
    },
    page: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      isLoading: false,
      items: [],
      pagination: {
        total: 0,
        pageSize: 10
      }
    }
  },

  created() {
    this.fetch()
  },

  methods: {
    async fetch() {
      try {
        this.isLoading = true

        const {
          data: { status, result }
        } = await ReceiptService.getAll({
          search: this.query || undefined,
          datetime_before: this.end ? moment(this.end).format() : undefined,
          datetime_after: this.start ? moment(this.start).format() : undefined,
          action_type: this.type || undefined,
          page: this.page || undefined,
          page_size: this.pagination.pageSize
        })

        if (status === 'error')
          throw new Error('เกิดข้อผิดพลาดในการรับข้อมูลรายการ')

        this.items = result.results.map(item => ({
          id: item.id,
          displayId: item.display_id,
          warrantyCardNo: item.insurance_number,
          datetime: new Date(item.datetime),
          type: item.action_type,
          customer: item.customer ? item.customer.full_name : 'ไม่ระบุ',
          amount: +item.grand_total,
          seller: item.user
            ? `${item.user.first_name} ${item.user.last_name}`.trim()
            : ''
        }))

        this.pagination = {
          ...this.pagination,
          total: result.count
        }
      } catch (err) {
        this.$notify.error(err.message)
      } finally {
        this.isLoading = false
      }
    }
  },

  render() {
    return (
      <el-card
        {...{ directives: [{ name: 'loading', value: this.isLoading }] }}
        element-loading-background="rgba(0, 0, 0, 0.75)"
        element-loading-custom-class={elementUiStyles.loadingMask}
      >
        <ResultCounter value={this.pagination.total}>ผลลัพธ์</ResultCounter>
        <el-table data={this.items} style={{ marginTop: '1rem' }}>
          <el-table-column label="ID" prop="displayId" minWidth="130" />
          <el-table-column
            label="วันที่"
            minWidth="145"
            scopedSlots={{
              default: ({ row }) => this.$_datetime_toThaiDatetime(row.datetime)
            }}
          />
          <el-table-column
            label="กิจกรรม"
            minWidth="110"
            scopedSlots={{
              default: ({ row }) => <ActivityTag type={row.type} />
            }}
          />
          <el-table-column
            label="ลูกค้า"
            prop="customer"
            minWidth="150"
            className={elementUiStyles.normalWordBreakCell}
          />
          <el-table-column
            label="มูลค่า"
            align="right"
            minWidth="120"
            scopedSlots={{
              default: ({ row }) => this.$_number_toFormattedNumber(row.amount)
            }}
          />
          <el-table-column
            label="ผู้ขาย"
            prop="seller"
            minWidth="150"
            className={elementUiStyles.normalWordBreakCell}
          />
          <el-table-column
            width="150"
            scopedSlots={{
              default: ({ row }) => (
                <SeeDetailButton type={row.type} receiptId={row.id} />
              )
            }}
          />
        </el-table>
        <div
          style={{
            display: 'flex',
            overflow: 'auto hidden',
            marginTop: '1rem'
          }}
        >
          <el-pagination
            background
            currentPage={this.page}
            total={this.pagination.total}
            pageSize={this.pagination.pageSize}
            layout="prev, pager, next, jumper"
            style={{ margin: 'auto' }}
            on={{
              'update:currentPage': value => {
                this.$emit('update:page', value)
              },
              'current-change': value => {
                this.$emit('page-change', value)
              }
            }}
          ></el-pagination>
        </div>
      </el-card>
    )
  }
})

export default {
  components: {
    ActionBar,
    ActionBarTitle,
    PageContainer,
    Container,
    HistoryFilter,
    HistoryResult
  },

  data() {
    const { query } = this.$route

    return {
      query: {
        q: query.q || '',
        type: query.type || '',
        start: query.start ? new Date(query.start) : undefined,
        end: query.end ? new Date(query.end) : undefined,
        page: query.page ? +query.page : null
      }
    }
  },

  methods: {
    replaceQuery() {
      const query = {
        q: this.query.q || undefined,
        type: this.query.type || undefined,
        start: this.query.start ? moment(this.query.start).format() : undefined,
        end: this.query.end ? moment(this.query.end).format() : undefined,
        page: this.query.page || undefined
      }

      this.$router.replace({ query })
    },

    handleSubmit() {
      this.query = {
        ...this.query,
        page: null
      }

      this.replaceQuery()

      this.$nextTick(() => {
        this.$refs.result.fetch()
      })
    },

    handlePageChange() {
      this.replaceQuery()

      this.$nextTick(() => {
        this.$refs.result.fetch()
      })
    }
  }
}
</script>
